import _ from "lodash";

export default function ({ store, redirect, route }){
	const user = store.state.auth.user || JSON.parse(localStorage.getItem(process.env.cookieName));
	
	const myRoutes = _.filter(process.env.routes, route => {
		return route.permissions.includes(user?.role ?? "guest");
	});

	let hasPermission = _.findIndex(myRoutes, (myRoute) => route.name == myRoute.name);
	if(hasPermission < 0) return redirect(myRoutes[0].path);

	if(user && !store.state.auth.user){
		store.commit("auth/setUser", user);
	}
}